import { render, staticRenderFns } from "./Parent_calculate.vue?vue&type=template&id=9aa0ca0e&scoped=true"
import script from "./Parent_calculate.vue?vue&type=script&lang=js"
export * from "./Parent_calculate.vue?vue&type=script&lang=js"
import style0 from "./Parent_calculate.vue?vue&type=style&index=0&id=9aa0ca0e&prod&lang=css"
import style1 from "./Parent_calculate.vue?vue&type=style&index=1&id=9aa0ca0e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa0ca0e",
  null
  
)

export default component.exports